import React from 'react';

export default function MailIcon(): JSX.Element {
  return (
    <svg viewBox="0 0.5 10 5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M.736 0a.938.938 0 00-.404.075l4.42 3.547c.18.087.316.087.496 0L9.668.075A.894.894 0 009.28 0H.736zM.034.45C.013.53 0 .62 0 .72v4.56c0 .123.017.23.05.322l3.128-2.617L.034.45zm9.936 0L6.822 2.985 9.95 5.602A1.01 1.01 0 0010 5.27V.709c0-.096-.01-.183-.03-.259zM3.567 3.292L.393 5.947C.49 5.983.608 6 .743 6h8.53a.995.995 0 00.334-.053L6.433 3.292c-.317.252-.64.517-.957.762-.302.148-.65.148-.952 0-.32-.246-.64-.508-.957-.762z"
          id="mailIcon"
        />
      </defs>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#mailIcon" />
    </svg>
  );
}
